enum GameNames {
  Savannah = "Savannah",
  AudioCall = "Audio Call",
  Sprint = "Sprint",
  OwnGame = "Own Game",
}

export default GameNames;
